export const ApiToken = {
  // // !测试站点
  // flag: false,
  // token: 'UpToken',
  // baseUrl: 'https://events.schneider-electric.cn/ciif-test/Api',
  // baseApi: '',
  // shareUrl: 'https://events.schneider-electric.cn/ciif-test',
  // UrlBase: '',
  // Url: '',
  // surveyTime: '2023-08-25 09: 00: 00',
  // Cpath: '/ciif-test/',

  // !正式站点
  flag: true,
  token: 'UpTokenCase',
  baseUrl: 'https://events.schneider-electric.cn/ciif2023/Api', //正式
  baseApi: '',
  shareUrl: 'https://events.schneider-electric.cn/ciif2023',
  UrlBase: '', 
  Url: '',
  surveyTime: '2023-09-19 09: 00: 00',
  Cpath: '/ciif2023/'
}
